/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10,20,30 places a bubble at (10,20) sized by 30.`)
};

const es_bubble_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10,20,30 coloca una burbuja en (10,20) con tamaño 30.`)
};

const de_bubble_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10,20,30 platziert eine Blase bei (10,20) mit der Größe 30.`)
};

const nl_bubble_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10,20,30 plaatst een bel op (10,20) met grootte 30.`)
};

const fr_bubble_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10,20,30 place une bulle en (10,20) dimensionnée à 30.`)
};

const it_bubble_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10,20,30 posiziona una bolla in (10,20) dimensionata da 30.`)
};

const pt_br2_bubble_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10,20,30 posiciona uma bolha em (10,20) com tamanho 30.`)
};

const pt_bubble_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10,20,30 coloca uma bolha em (10,20) com tamanho 30.`)
};

const ja_bubble_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10,20,30 は (10,20) にサイズ30のバブルを配置します。`)
};

const zh_bubble_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10,20,30 在 (10,20) 处放置一个大小为 30 的气泡。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_ex1", locale)
	if (locale === "en") return en_bubble_ex1(inputs)
	if (locale === "es") return es_bubble_ex1(inputs)
	if (locale === "de") return de_bubble_ex1(inputs)
	if (locale === "nl") return nl_bubble_ex1(inputs)
	if (locale === "fr") return fr_bubble_ex1(inputs)
	if (locale === "it") return it_bubble_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_ex1(inputs)
	if (locale === "pt") return pt_bubble_ex1(inputs)
	if (locale === "ja") return ja_bubble_ex1(inputs)
	return zh_bubble_ex1(inputs)
};